/**
 * Accessible font options for EPUB reader.
 * Each font includes fallback families for graceful degradation.
 */
export const ACCESSIBLE_FONTS = [
    {
        id: 'default',
        labelKey: 'fontDefault',
        value: null,
        cssStack: 'inherit',
    },
    {
        id: 'literata',
        label: 'Literata',
        value: "'Literata', Georgia, serif",
        cssStack: "'Literata', Georgia, serif",
    },
    {
        id: 'inter',
        label: 'Inter',
        value: "'Inter', system-ui, sans-serif",
        cssStack: "'Inter', system-ui, sans-serif",
    },
    {
        id: 'jetbrains-mono',
        label: 'JetBrains Mono',
        value: "'JetBrains Mono', monospace",
        cssStack: "'JetBrains Mono', monospace",
    },
    {
        id: 'opendyslexic',
        label: 'OpenDyslexic',
        value: "'OpenDyslexic', Arial, sans-serif",
        cssStack: "'OpenDyslexic', Arial, sans-serif",
    },
];

/**
 * Finds a font option by its CSS value.
 * @param {string|null} fontValue - CSS font-family value
 * @returns {Object|undefined} Font option object
 */
export function findFontByValue(fontValue) {
    return ACCESSIBLE_FONTS.find(font => font.value === fontValue);
}
